import fontSizes from '../../../theme/displate/fontSizes';
import { TextSizeType } from './BaseText.enum';
const handleTextFontSize = (size = TextSizeType.TEXT16) => {
    switch (size) {
        case TextSizeType.TEXT12:
            return fontSizes.sizeSm2;
        case TextSizeType.TEXT14:
            return fontSizes.sizeSm3;
        case TextSizeType.TEXT18:
            return fontSizes.sizeMd2;
        case TextSizeType.TEXT16:
        default:
            return fontSizes.sizeMd1;
    }
};
const handleTextLineHeight = (size = TextSizeType.TEXT16) => {
    switch (size) {
        case TextSizeType.TEXT12:
            return '16px';
        case TextSizeType.TEXT14:
            return '20px';
        case TextSizeType.TEXT18:
            return '32px';
        case TextSizeType.TEXT16:
        default:
            return '24px';
    }
};
export { handleTextFontSize, handleTextLineHeight };
//# sourceMappingURL=BaseText.helpers.js.map